<template>
  <div>
    <v-row>
      <template v-for="item of aboutNews">
        <v-col :key="item.news_id" cols="12" md="6">
          <NewsCard
            :border="parseInt(item) <= 4-2"
            :image="item.image_path"
            :title="item[`title_${lang}`]"
            :description="item[`intro_${lang}`]"
            :date="item.publish_date | moment('DD MMM')"
            :viewer="item.viewer"
            class="cursor-pointer"
            @click.native="newsHandler(item.news_id)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col>
        <GreenButton label="read more" @click.native="readMoreHandler" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NewsCard from "../cards/NewsCard";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';

export default {
  components: {
    NewsCard,
    GreenButton
  },
  computed: {
    ...mapState({
      aboutNews: state => state.About.news.data,
      lang: state => state.Branch.lang
    })
  },
  methods: {
    newsHandler(id) {
      this.$router.push(`/about/news/${id}`);
    },
    readMoreHandler() {
      this.$router.push("/about/news");
    }
  }
};
</script>

<style>
</style>
